/* eslint-disable no-negated-condition -- needed */
import type { ButtonProps } from '@ori-ui/mui';
import { Button } from '@ori-ui/mui';
import { useFormatCurrency } from '@ori/culture-provider';
import { forwardRef } from 'react';

import { useAppContext } from '../contexts';
import { useTranslations } from '../hooks/useTranslations';

export const BuyForPointsButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { loyaltyPrice, loyaltyPoints } = useAppContext();
  const { formatMessage } = useTranslations();
  const plusLoyaltyPrice = ` + ${useFormatCurrency(loyaltyPrice ?? 0)}`;

  return (
    <Button
      ref={ref}
      fullWidth
      variant="contained"
      color="primary"
      {...props}
    >
      {formatMessage('pointsCount', { 0: loyaltyPoints ?? 0 })}
      {loyaltyPrice !== 0 ? plusLoyaltyPrice : null}
    </Button>
  );
});
